import {
  apiRequest,
  processInput
} from "@/utilities"

export const prefixService = {
  async getPrefixes() {
    const getPrefixesRequest = {
      method: "GET"
    }
    return await apiRequest("/api/prefixes", getPrefixesRequest)
  },
  async getPrefix(uuid) {
    const getPrefixRequest = {
      method: "GET"
    }
    return await apiRequest(`/api/prefixes/${uuid}`, getPrefixRequest)
  },
  async createPrefix(params) {
    const createData = processInput(params)
    const createPrefixRequest = {
      method: "POST",
      data: createData
    }
    return await apiRequest("/api/prefixes", createPrefixRequest)
  },
  async editPrefix(params) {
    const { uuid } = params;
    delete params.uuid
    let data = processInput(params)
    data.append("_method", "PATCH")
    const editPrefixRequest = {
      method: "POST",
      data
    }
    return await apiRequest(`/api/prefixes/${uuid}`, editPrefixRequest)
  },
  async deletePrefix(uuid) {
    const deletePrefixRequest = {
      method: "DELETE"
    }
    return await apiRequest(`/api/prefixes/${uuid}`, deletePrefixRequest)
  },
  async reorderPrefixes(params) {
    let data = processInput(params)
    const reorderPrefixRequest = {
      method: "POST",
      data
    }
    return await apiRequest("/api/prefixes-reorder", reorderPrefixRequest)
  }
}
